"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeDeleteConciergeVendor = exports.conciergeUpdateConciergeVendor = exports.conciergeCreateConciergeVendor = exports.conciergeGetConciergeVendorsWithFilters = exports.conciergeGetConciergeVendorById = void 0;
const client_1 = require("@apollo/client");
const fragments_graphql_1 = require("../fragments.graphql");
exports.conciergeGetConciergeVendorById = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_ATTACHMENT_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONTACT_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_BID_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONCIERGE_RATINGS_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_PROCURE_RATINGS_FIELDS}
  query conciergeGetConciergeVendorById($id: ID!) {
    conciergeGetConciergeVendorById(id: $id) {
      ...ConciergeVendorFields
      conciergeVendorContacts {
        ...ConciergeVendorContactFields
      }
      workOrderBids {
        ...WorkOrderBidFields
      }
      conciergeVendorConciergeRatings {
        ...ConciergeVendorConciergeRatingFields
      }
      conciergeVendorProcureRatings {
        ...ConciergeVendorProcureRatingFields
      }
      ...ConciergeVendorAttachmentFields
    }
  }
`;
exports.conciergeGetConciergeVendorsWithFilters = (0, client_1.gql) `
  ${fragments_graphql_1.CONCIERGE_VENDOR_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONTACT_FIELDS}
  ${fragments_graphql_1.WORK_ORDER_BID_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_CONCIERGE_RATINGS_FIELDS}
  ${fragments_graphql_1.CONCIERGE_VENDOR_PROCURE_RATINGS_FIELDS}
  query conciergeGetConciergeVendorsWithFilters(
    $radius: Int
    $city: String
    $state: String
    $address1: String
    $address2: String
  ) {
    conciergeGetConciergeVendorsWithFilters(
      radius: $radius
      city: $city
      state: $state
      address1: $address1
      address2: $address2
    ) {
      ...ConciergeVendorFields
      conciergeVendorContacts {
        ...ConciergeVendorContactFields
      }
      workOrderBids {
        ...WorkOrderBidFields
      }
      conciergeVendorConciergeRatings {
        ...ConciergeVendorConciergeRatingFields
      }
      conciergeVendorProcureRatings {
        ...ConciergeVendorProcureRatingFields
      }
    }
  }
`;
exports.conciergeCreateConciergeVendor = (0, client_1.gql) `
  mutation conciergeCreateConciergeVendor($input: ConciergeVendorCreateInput!) {
    conciergeCreateConciergeVendor(input: $input) {
      id
    }
  }
`;
exports.conciergeUpdateConciergeVendor = (0, client_1.gql) `
  mutation conciergeUpdateConciergeVendor($id: ID!, $input: ConciergeVendorUpdateInput!) {
    conciergeUpdateConciergeVendor(id: $id, input: $input) {
      id
    }
  }
`;
exports.conciergeDeleteConciergeVendor = (0, client_1.gql) `
  mutation conciergeDeleteConciergeVendor($id: ID!) {
    conciergeDeleteConciergeVendor(id: $id) {
      id
    }
  }
`;
//# sourceMappingURL=concierge-vendor.queries.graphql.js.map